
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 37 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.35 36.642a.422.422 0 00.408-.617 13.286 13.286 0 01-1.54-5.045.42.42 0 00-.363-.376 21.518 21.518 0 01-10.358-3.72.42.42 0 00-.685.326v2.88c0 3.216 5.372 5.894 12.538 6.552zM.812 22.538c0 2.969 4.577 5.483 10.917 6.378a.412.412 0 00.319-.088.423.423 0 00.158-.292c.133-1.641.57-3.244 1.287-4.726a.42.42 0 00-.336-.6c-4.66-.449-9.062-1.761-11.659-3.86a.42.42 0 00-.684.325l-.002 2.863zM16.757 15.825c-5.874 0-12.01-1.398-15.26-4.046a.42.42 0 00-.685.325v2.882c0 3.402 6.008 6.21 13.792 6.648a.42.42 0 00.356-.168 13.337 13.337 0 0116.203-3.986.416.416 0 00.485-.1 3.575 3.575 0 001.05-2.4v-2.872a.418.418 0 00-.682-.326c-3.253 2.647-9.378 4.043-15.259 4.043z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.757 14.147c8.806 0 15.944-3.006 15.944-6.713C32.7 3.726 25.563.72 16.757.72 7.952.72.814 3.726.814 7.434c0 3.707 7.138 6.713 15.943 6.713zM25.566 18.762a10.908 10.908 0 1010.909 10.909 10.921 10.921 0 00-10.91-10.909zm0 19.3a1.259 1.259 0 01-1.259-1.259v-.42a.42.42 0 00-.42-.419h-.838a1.259 1.259 0 110-2.517h3.411a.994.994 0 00.37-1.915l-3.464-1.387a3.497 3.497 0 01.605-6.679.419.419 0 00.336-.411v-.517a1.259 1.259 0 012.518 0v.42a.416.416 0 00.42.42h.838a1.259 1.259 0 110 2.517H24.67a.994.994 0 00-.37 1.914l3.464 1.387a3.498 3.498 0 01-.605 6.68.42.42 0 00-.336.41v.517a1.259 1.259 0 01-1.257 1.259z","fill":"currentColor"}})])
          )
        }
      }
    